import React from 'react'
import { Helmet } from "react-helmet";
import ApplicationForm from '../../components/Apply/ApplicationForm'

const Apply = () => {
  return (
    <>
<Helmet>
  {/* Google Analytics Tag */}
  <script async src="https://www.googletagmanager.com/gtag/js?id=AW-16818142902"></script>
  <script>
    {`
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'AW-16818142902');
    `}
  </script>

  {/* Basic Meta */}
  <title>Apply Now | Aptech Lekki Centre - Start Your Tech Career Today</title>
  <meta charSet="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />

  <meta
    name="description"
    content="Ready to kickstart your tech career? Apply to Aptech Lekki Centre and enroll in top-rated IT courses like Web Development, Software Engineering, Data Analytics, Mobile App Development, and more. Take the first step towards global certification and career success."
  />

  <meta
    name="keywords"
    content="Apply Aptech Lekki, Enroll in coding courses Nigeria, IT training application Lekki, Software engineering application Nigeria, Start tech journey Lagos, Apply for web development course, Learn programming Lekki, Become a software engineer Nigeria, Join Aptech Centre Lekki"
  />

  <meta name="author" content="Aptech Lekki Centre" />
  <meta name="robots" content="index, follow" />
  <link rel="canonical" href="https://aptechlekki.com/apply" />

  {/* Open Graph Meta */}
  <meta property="og:title" content="Apply Now | Aptech Lekki Centre" />
  <meta property="og:description" content="Take the first step towards a tech career. Apply online at Aptech Lekki Centre today and join Nigeria’s leading IT training institute." />
  <meta property="og:url" content="https://aptechlekki.com/apply" />
  <meta property="og:type" content="website" />
  <meta property="og:image" content="https://aptechlekki.com/assets/og_image.jpg" />

  {/* Twitter Card */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="Apply Now | Aptech Lekki Centre" />
  <meta name="twitter:description" content="Enroll at Aptech Lekki and start your journey to becoming a tech professional. Apply now!" />
  <meta name="twitter:image" content="https://aptechlekki.com/assets/og_image.jpg" />
</Helmet>

    <ApplicationForm />
    </>
  )
}

export default Apply